export const claddingIds = {
  brickguards: 'f8113dc8-5c84-41de-891b-1c47940dc0ee',
  sheeting: '6806452b-1385-475b-b8f7-372e2c676f98',
  netting: '20c761ff-7f7f-4c3f-bf1a-eb15d72c14fb',
  other: '2f90521f-3e46-4a09-9ab6-382906f05f70',
  none: '527be580-724d-41c8-9391-86727780d11e'
};
